import { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom'; //added 'Link'
import axios from 'axios';
import { AuthContext } from '../context/AuthContext';
import { useContext } from 'react';
import { ChevronDownIcon, ChevronUpIcon, Bars3Icon } from '@heroicons/react/24/outline'; //added for navigation slider
import watermarkImage from '../assets/coverzone-watermark.png'; // Update this path to your actual image
import logoImage from '../assets/FullLogo_1.png';
import topLogoImage from '../assets/brokerlogo.png';
import Header from '../Header';
import Sidebar from '../Sidebar';

const API_URL = process.env.REACT_APP_API_URL;

interface Instruction {
  id: string;
  created_date: string;
  updated_date?: string;  // ADD THIS
  reference_number: string;
  client_name: string;
  client_id?: string;
  status: string;
  consultant_name: string;
  instruction_type: string;
  description: string;
}

interface Consultant {
  id: string;
  name: string;
  surname: string;
  email: string;
}

interface Client {
  id: string;
  name: string;
  surname: string;
  email: string;
  client_type?: string;
  contact_number?: string; // Add this line
  mobile_number?: string;
  telephone_number?: string;
  organization?: string;
  personal?: boolean;
  commercial?: boolean;
  medical?: boolean;
  client_number?: string;
  middle_names?: string;
  nickname?: string;
  date_of_birth?: string;
  id_passport_number?: string;
  fax_number?: string;
  marital_status?: string;
  gender?: string;
  language?: string;
  drivers_license_codes?: string;
  employer_name?: string;
  tax_number?: string;
  job_description?: string;
  consultant?: string;
  created_date?: string;
  updated_date?: string;
}

interface CreateInstructionForm {
  client_type: string;
  client_id: string;
  client_name: string;
  instruction_type: string;
  instruction_method: string;
  description: string;
  consultant_id?: string;
}

const Instructions = () => {
  const [user, setUser] = useState<{ id: number; email: string; username?: string; organization?: string } | null>(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false); //added for navigation slider
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);
  const [instructions, setInstructions] = useState<Instruction[]>([]);
  const [consultants, setConsultants] = useState<Consultant[]>([]);
  const [clients, setClients] = useState<Client[]>([]);
  const [filteredInstructions, setFilteredInstructions] = useState<Instruction[]>([]);
  const [filteredClients, setFilteredClients] = useState<Client[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [searchInstructionTerm, setSearchInstructionTerm] = useState('');
  const [searchConsultantTerm, setSearchConsultantTerm] = useState('');
  const [currentUserFullName, setCurrentUserFullName] = useState<string>('');
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [clientSearchTerm, setClientSearchTerm] = useState('');
  const [createFormData, setCreateFormData] = useState<CreateInstructionForm>({
    client_type: '',
    client_id: '',
    client_name: '',
    instruction_type: '',
    instruction_method: '',
    description: ''
  });
  const [createFormErrors, setCreateFormErrors] = useState<Partial<CreateInstructionForm>>({});
  const [createSuccessMessage, setCreateSuccessMessage] = useState<string | null>(null);
  const [assignToDifferentConsultant, setAssignToDifferentConsultant] = useState(false);
  const [consultantSearchTerm, setConsultantSearchTerm] = useState('');
  const [filteredConsultants, setFilteredConsultants] = useState<Consultant[]>([]);
  const [selectedConsultantId, setSelectedConsultantId] = useState<string>('');
  const authContext = useContext(AuthContext);
  const navigate = useNavigate();

  // Fetch user data
  useEffect(() => {
  const fetchUser = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/auth/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setUser(response.data);
      
      // Set current user's full name for consultant search
      const userData = response.data;
      const fullName = userData.username || userData.email || '';
      if (fullName) {
        setCurrentUserFullName(fullName);
        setSearchConsultantTerm(fullName);
      }
    } catch (error) {
      console.error('Error fetching user:', error);
      // Also check localStorage if API fails
      const storedUser = localStorage.getItem('user');
      if (storedUser) {
        try {
          const userData = JSON.parse(storedUser);
          const fullName = userData.username || userData.email || userData.name || '';
          if (fullName) {
            setCurrentUserFullName(fullName);
            setSearchConsultantTerm(fullName);
          }
        } catch (e) {
          console.error('Error parsing stored user:', e);
        }
      }
      localStorage.removeItem('token');
      navigate('/login');
    }
  };
  fetchUser();
}, [navigate]);

  // Fetch instructions
  useEffect(() => {
    const fetchInstructions = async () => {
  setIsLoading(true);
  setError(null);
  try {
    const token = localStorage.getItem('token');
    if (!token) throw new Error('No authentication token found');

    const response = await axios.get(`${API_URL}/api/clients_personal_instructions`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    
    //console.log('✅ Instructions data received:', response.data);
    if (response.data.success) {
      const instructionsData = response.data.data || [];
      // Filter to only show Open instructions (not completed)
      const openInstructions = instructionsData
  .filter((instruction: any) => instruction.status?.toLowerCase() !== 'completed')
  .map((instruction: any) => {
    // Log the instruction to see what fields are available
    console.log('📋 Instruction data:', instruction);
    console.log('🔍 Available fields:', Object.keys(instruction));
    
    return {
      ...instruction,
      // Try multiple possible field names for client ID
      client_id: instruction.client_id || 
                  instruction.clientId || 
                  instruction.clientID || 
                  instruction.ClientId ||
                  instruction.ClientID ||
                  instruction.client?.id ||
                  instruction.client?.clientId ||
                  instruction.client?.client_id ||
                  '',
                  updated_date: instruction.updated_date || instruction.updated_at || instruction.created_date
    };
  });
console.log('✅ Mapped instructions with client_id:', openInstructions);
setInstructions(openInstructions);
setFilteredInstructions(openInstructions);
    } else {
      throw new Error(response.data.message || 'Failed to fetch instructions');
    }
  } catch (error: any) {
    //console.error('❌ Error fetching instructions:', error);
    setError(error.response?.data?.message || 'Failed to load instructions');
    
    // Fallback to mock data - only Open
    const mockInstructions: Instruction[] = [
  {
    id: '1',
    created_date: '2024-01-15',
    reference_number: 'REF-001',
    client_name: 'Sample Client',
    client_id: '1', // Add a sample client_id
    status: 'Open',
    consultant_name: 'Sample Consultant',
    instruction_type: 'New Product',
    description: 'Sample instruction description'
  }
];
    setInstructions(mockInstructions);
    setFilteredInstructions(mockInstructions);
  } finally {
    setIsLoading(false);
  }
};

    fetchInstructions();
  }, []);

    // Fetch consultants
    useEffect(() => {
      const fetchConsultants = async () => {
        try {
          const token = localStorage.getItem('token');
          if (!token) throw new Error('No authentication token found');

          const response = await axios.get(`${API_URL}/api/consultants`, {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          });
          
          //console.log('✅ Consultants data received:', response.data);
          if (response.data.success) {
            const consultantsData = response.data.data || [];
            setConsultants(consultantsData);
          }
        } catch (error: any) {
          //console.error('❌ Error fetching consultants:', error);
        }
      };

      fetchConsultants();
    }, []);

    // Fetch clients
    useEffect(() => {
  const fetchClients = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) throw new Error('No authentication token found');

      const response = await axios.get(`${API_URL}/api/clients`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      
      //console.log('✅ Clients data received:', response.data);
      
      // Your backend returns the array directly, not wrapped in success/data
      if (Array.isArray(response.data)) {
        const clientsData = response.data.map((client: any) => ({
          id: client.id.toString(),
          name: client.name || '',
          surname: client.surname || '',
          email: client.email || '',
          client_type: client.personal ? 'Personal Client' : client.commercial ? 'Commercial Client' : 'Unknown',
          contact_number: client.mobile_number || client.telephone_number || '',
          mobile_number: client.mobile_number || '',
          telephone_number: client.telephone_number || '',
          organization: client.organization || '',
          // Add other fields as needed
        }));
        
        setClients(clientsData);
        setFilteredClients(clientsData);
        //console.log('✅ Processed clients:', clientsData.length);
      } else {
        //console.error('❌ Unexpected clients response format:', response.data);
        throw new Error('Unexpected response format from clients endpoint');
      }
    } catch (error: any) {
      console.error('❌ Error fetching clients:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status
      });
      
      // Enhanced fallback to mock clients for testing
      //console.log('🔄 Using enhanced mock clients data');
      const mockClients: Client[] = [
        {
          id: '1',
          name: 'John',
          surname: 'Doe',
          email: 'john.doe@example.com',
          client_type: 'Personal Client',
          contact_number: '+1234567890',
          mobile_number: '+1234567890',
          organization: 'ABC Corp'
        },
        {
          id: '2',
          name: 'Jane',
          surname: 'Smith',
          email: 'jane.smith@example.com',
          client_type: 'Commercial Client',
          contact_number: '+1234567891',
          mobile_number: '+1234567891',
          organization: 'XYZ Ltd'
        },
        {
          id: '3',
          name: 'Robert',
          surname: 'Johnson',
          email: 'robert.johnson@example.com',
          client_type: 'Personal Client',
          contact_number: '+1234567892',
          mobile_number: '+1234567892'
        },
        {
          id: '4',
          name: 'Sarah',
          surname: 'Williams',
          email: 'sarah.williams@example.com',
          client_type: 'Commercial Client',
          contact_number: '+1234567893',
          mobile_number: '+1234567893',
          organization: 'Global Solutions'
        },
        {
          id: '5',
          name: 'Michael',
          surname: 'Brown',
          email: 'michael.brown@example.com',
          client_type: 'Personal Client',
          contact_number: '+1234567894',
          mobile_number: '+1234567894'
        },
        {
          id: '6',
          name: 'Emily',
          surname: 'Davis',
          email: 'emily.davis@example.com',
          client_type: 'Commercial Client',
          contact_number: '+1234567895',
          mobile_number: '+1234567895',
          organization: 'Tech Innovations'
        }
      ];
      
      setClients(mockClients);
      setFilteredClients(mockClients);
      
      // Show info message about using mock data
      setError('Using demo client data - Backend clients endpoint returned unexpected format');
    }
  };

  fetchClients();
}, []);

    // Filter clients based on search term
    useEffect(() => {
      if (clientSearchTerm.trim()) {
        const lowercasedSearch = clientSearchTerm.toLowerCase();
        const filtered = clients.filter(client =>
          client.name?.toLowerCase().includes(lowercasedSearch) ||
          client.surname?.toLowerCase().includes(lowercasedSearch) ||
          client.email?.toLowerCase().includes(lowercasedSearch) ||
          `${client.name} ${client.surname}`.toLowerCase().includes(lowercasedSearch)
        );
        setFilteredClients(filtered);
      } else {
        setFilteredClients(clients);
      }
    }, [clientSearchTerm, clients]);

    // Filter consultants based on search term
    useEffect(() => {
      if (consultantSearchTerm.trim()) {
        const lowercasedSearch = consultantSearchTerm.toLowerCase();
        const filtered = consultants.filter(consultant =>
          consultant.name?.toLowerCase().includes(lowercasedSearch) ||
          consultant.surname?.toLowerCase().includes(lowercasedSearch) ||
          consultant.email?.toLowerCase().includes(lowercasedSearch) ||
          `${consultant.name} ${consultant.surname}`.toLowerCase().includes(lowercasedSearch)
        );
        setFilteredConsultants(filtered);
      } else {
        setFilteredConsultants(consultants);
      }
    }, [consultantSearchTerm, consultants]);

    // Handle create instruction form input changes
    const handleCreateInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
      const { name, value } = e.target;
      setCreateFormData(prev => ({ ...prev, [name]: value }));
      setCreateFormErrors(prev => ({ ...prev, [name]: '' }));
    };

    // Handle client selection
    const handleClientSelect = (clientId: string, clientName: string) => {
      setCreateFormData(prev => ({ 
        ...prev, 
        client_id: clientId,
        client_name: clientName 
      }));
      setClientSearchTerm(clientName);
    };

    // Handle consultant selection
    const handleConsultantSelect = (consultantId: string, consultantName: string) => {
      setSelectedConsultantId(consultantId);
      setCreateFormData(prev => ({ ...prev, consultant_id: consultantId }));
      setConsultantSearchTerm(consultantName); // Set the search term to the selected consultant's name
    };

    // Validate create form
    const validateCreateForm = () => {
      const errors: Partial<CreateInstructionForm> = {};
      if (!createFormData.client_type) errors.client_type = 'Client type is required';
      if (!createFormData.client_id) errors.client_id = 'Client is required';
      if (!createFormData.instruction_type) errors.instruction_type = 'Instruction type is required';
      if (!createFormData.instruction_method) errors.instruction_method = 'Instruction method is required';
      if (!createFormData.description) errors.description = 'Description is required';
      return errors;
    };

    // Handle create instruction submission
    const handleCreateSubmit = async (e: React.FormEvent) => {
      e.preventDefault();
      const errors = validateCreateForm();
      if (Object.keys(errors).length > 0) {
        setCreateFormErrors(errors);
        return;
      }

      try {
        const token = localStorage.getItem('token');
        const response = await axios.post(`${API_URL}/api/clients_personal_instructions`, createFormData, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        //console.log('✅ Instruction creation response:', response.data);
        if (response.status === 201) {
          // Add the new instruction to the list
          const newInstruction = response.data.data;
          setInstructions(prev => [newInstruction, ...prev]);
          setCreateSuccessMessage('Instruction created successfully!');
          setIsCreateModalOpen(false);
          setCreateFormData({
            client_type: '',
            client_id: '',
            client_name: '',
            instruction_type: '',
            instruction_method: '',
            description: ''
          });
          setTimeout(() => setCreateSuccessMessage(null), 3000);
        } else {
          setError(response.data.message || 'Failed to create instruction');
        }
      } catch (error: any) {
        //console.error('❌ Error creating instruction:', error);
        setError(error.response?.data?.message || 'Failed to create instruction');
      }
    };

    // Open create modal
    const handleOpenCreateModal = () => {
      setIsCreateModalOpen(true);
      setCreateFormErrors({});
      setClientSearchTerm('');
      setAssignToDifferentConsultant(false);
      setConsultantSearchTerm('');
      setSelectedConsultantId('');
    };

  // Search Consultant - filter by consultant name
  useEffect(() => {
    let filtered = instructions;

    // Search Instructions - search in clients_personal_instructions table fields
if (searchInstructionTerm.trim()) {
  const lowercasedSearch = searchInstructionTerm.toLowerCase().trim();
  filtered = filtered.filter(instruction =>
    instruction.reference_number?.toLowerCase().includes(lowercasedSearch) ||
    instruction.instruction_type?.toLowerCase().includes(lowercasedSearch) ||
    instruction.description?.toLowerCase().includes(lowercasedSearch) ||
    instruction.client_name?.toLowerCase().includes(lowercasedSearch) ||
    // Search for "open" status
    'open'.includes(lowercasedSearch)
  );
}

    // Search Consultant - filter by consultant name
    if (searchConsultantTerm.trim()) {
      const lowercasedSearch = searchConsultantTerm.toLowerCase().trim();
      
      filtered = filtered.filter(instruction => {
        const instructionConsultantName = instruction.consultant_name?.toLowerCase().trim() || '';
        return instructionConsultantName.includes(lowercasedSearch);
      });
    }

    setFilteredInstructions(filtered);
  }, [searchInstructionTerm, searchConsultantTerm, instructions]);

  const handleLogout = () => {
    authContext?.setUser(null);
    localStorage.removeItem('token');
    navigate('/login');
  };

  //added for navigation slider
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const toggleSidebar = () => {
    setIsSidebarVisible(!isSidebarVisible);
  };

  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    console.error('Failed to load watermark image:', e);
  };

  const handleImageLoad = (type: string) => {
    //console.log(`${type} image loaded successfully`);
  };

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  if (!user) return <div>Loading...</div>;

  return (
    <div className="min-h-screen bg-gray-100 flex relative">

      {/* Watermark */}
      <div className="fixed inset-0 flex items-center justify-center pointer-events-none z-0">
        <img
          src={watermarkImage}
          alt="Watermark"
          className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-100 h-100 opacity-5 z-0 select-none"
          onError={handleImageError}
          onLoad={() => handleImageLoad('Watermark')}
        />
      </div>

      {/* Sidebar */}
      <Sidebar isVisible={isSidebarVisible} toggleSidebar={toggleSidebar} />

      {/* Main Content */}
      <div className={`flex-1 flex flex-col transition-all duration-300 ${isSidebarVisible ? 'ml-64' : 'ml-0'}`}>
        {/* Header */}
        <Header
          title="Instructions"
          user={user}
          toggleSidebar={toggleSidebar}
          isSidebarVisible={isSidebarVisible}
        />

        {/* Page Content */}
        <div className="flex-1 p-6 overflow-auto">
          {error && (
            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4">
              {error}
            </div>
          )}
          {createSuccessMessage && (
            <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mb-4">
              {createSuccessMessage}
            </div>
          )}

          <div className="bg-white rounded-lg shadow-md p-6 w-full max-w-[1600px] mx-auto">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-2xl font-bold">Instructions</h2>
              <button
                className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                onClick={handleOpenCreateModal}
              >
                Create Instruction
              </button>
            </div>

            {/* Search Fields */}
<div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
  <div>
    <label className="block text-sm font-medium text-gray-700 mb-2">
      Search Instructions
    </label>
    <div className="relative">
      <input
        type="text"
        placeholder="Search by reference, policy, type, description, client, or status..."
        value={searchInstructionTerm}
        onChange={(e) => setSearchInstructionTerm(e.target.value)}
        className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
      />
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <svg className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
      </div>
    </div>
  </div>

  <div>
    <label className="block text-sm font-medium text-gray-700 mb-2">
      Search Consultant
    </label>
    <div className="relative">
      <input
        type="text"
        placeholder="Search by consultant name, surname, or email..."
        value={searchConsultantTerm}
        onChange={(e) => setSearchConsultantTerm(e.target.value)}
        className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
      />
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <svg className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
      </div>
      {searchConsultantTerm && (
        <button
          onClick={() => setSearchConsultantTerm('')}
          className="absolute inset-y-0 right-0 pr-3 flex items-center"
        >
          <svg className="h-5 w-5 text-gray-400 hover:text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      )}
    </div>
  </div>
</div>

{/* Search Results Info */}
{(searchInstructionTerm || searchConsultantTerm) && (
  <div className="mb-4">
    <p className="text-sm text-gray-600">
      Showing {filteredInstructions.length} of {instructions.length} instructions
      {searchInstructionTerm && ` matching "${searchInstructionTerm}"`}
      {searchConsultantTerm && ` for consultant "${searchConsultantTerm}"`}
    </p>
  </div>
)}

            {/* Instructions List */}
            {isLoading ? (
              <div className="text-center py-8">
                <p className="text-gray-700">Loading instructions...</p>
              </div>
            ) : filteredInstructions.length === 0 ? (
              <div className="text-center py-8">
                {searchInstructionTerm || searchConsultantTerm ? (
                  <p className="text-gray-700">No instructions found matching your search criteria.</p>
                ) : (
                  <p className="text-gray-700">No instructions available.</p>
                )}
              </div>
            ) : (
              <div className="overflow-x-auto">
  <table className="min-w-full divide-y divide-gray-200">
    <thead className="bg-gray-50">
  <tr>
    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
      Date Created
    </th>
    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
      Last Updated
    </th>
    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
      Ref No
    </th>
    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
      Client Name
    </th>
    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
      Description
    </th>
    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
      Consultant
    </th>
    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
      Status
    </th>
  </tr>
</thead>
    <tbody className="bg-white divide-y divide-gray-200">
  {filteredInstructions.map((instruction) => (
    <tr key={instruction.id} className="hover:bg-gray-50">
      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
        {formatDate(instruction.created_date)}
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
        {formatDate(instruction.updated_date || instruction.created_date)}
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
        <button
          onClick={() => {
            if (instruction.client_id) {
              navigate(`/personal/${instruction.client_id}`, { 
                state: { 
                  activeTab: 'instructions',
                  instructionId: instruction.id 
                } 
              });
            } else {
              alert(`Cannot navigate to instruction details. No client associated with this instruction.`);
            }
          }}
          className="text-blue-600 hover:text-blue-800 hover:underline cursor-pointer"
        >
          {instruction.reference_number && instruction.reference_number !== 'N/A' 
            ? instruction.reference_number 
            : `INS-${String(instruction.id).padStart(3, '0')}`}
        </button>
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
        {instruction.client_name || 'N/A'}
      </td>
      <td className="px-6 py-4 text-sm text-gray-900">
        <div className="max-w-xs truncate" title={instruction.description}>
          {instruction.description || 'N/A'}
        </div>
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
        {instruction.consultant_name || 'N/A'}
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-sm">
        <span className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-yellow-100 text-yellow-800">
          Open
        </span>
      </td>
    </tr>
  ))}
</tbody>
  </table>
</div>
            )}
          </div>
        </div>
      </div>

      {/* Create Instruction Modal */}
      {isCreateModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <h2 className="text-xl font-bold mb-4">Create New Instruction</h2>
            <form onSubmit={handleCreateSubmit}>
              <div className="space-y-4">
                {/* Select Client Type */}
                <div>
                  <label className="block font-medium mb-1">Select Client Type *</label>
                  <select
                    name="client_type"
                    value={createFormData.client_type}
                    onChange={handleCreateInputChange}
                    className="w-full border p-2 rounded"
                  >
                    <option value="">Select client type</option>
                    <option value="Personal Client">Personal Client</option>
                    <option value="Commercial Client">Commercial Client</option>
                  </select>
                  {createFormErrors.client_type && (
                    <p className="text-red-500 text-sm mt-1">{createFormErrors.client_type}</p>
                  )}
                </div>

                {/* Find Client */}
                <div>
                  <label className="block font-medium mb-1">Find Client *</label>
                  <input
                    type="text"
                    placeholder="Type to search for clients..."
                    value={createFormData.client_id ? createFormData.client_name : clientSearchTerm}
                    onChange={(e) => setClientSearchTerm(e.target.value)}
                    className="w-full border p-2 rounded"
                  />
                  {createFormData.client_id && (
                    <p className="text-green-600 text-sm mt-1">Client selected: {createFormData.client_name}</p>
                  )}
                  {createFormErrors.client_id && (
                    <p className="text-red-500 text-sm mt-1">{createFormErrors.client_id}</p>
                  )}
                  
                  {/* Client Search Results */}
                  {clientSearchTerm && !createFormData.client_id && filteredClients.length > 0 && (
                    <div className="mt-2 max-h-40 overflow-y-auto border rounded">
                      {filteredClients.map(client => (
                        <div
                          key={client.id}
                          className="p-2 hover:bg-gray-100 cursor-pointer border-b"
                          onClick={() => handleClientSelect(client.id, `${client.name} ${client.surname}`)}
                        >
                          <div className="font-medium">{client.name} {client.surname}</div>
                          <div className="text-sm text-gray-600">{client.email}</div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* Select Policy */}
                <div>
                  <label className="block font-medium mb-1">Select Policy</label>
                  <select
                    name="policy_id"
                    onChange={handleCreateInputChange}
                    className="w-full border p-2 rounded"
                  >
                    <option value="">Select policy (coming soon)</option>
                    <option value="" disabled>Policy feature coming soon</option>
                  </select>
                  <p className="text-gray-500 text-sm mt-1">Policy selection will be available soon</p>
                </div>

                {/* Select Instruction Type */}
                <div>
                  <label className="block font-medium mb-1">Select Instruction Type *</label>
                  <select
                    name="instruction_type"
                    value={createFormData.instruction_type}
                    onChange={handleCreateInputChange}
                    className="w-full border p-2 rounded"
                  >
                    <option value="">Select instruction type</option>
                    <option value="New Product">New Product</option>
                    <option value="Existing Product">Existing Product</option>
                  </select>
                  {createFormErrors.instruction_type && (
                    <p className="text-red-500 text-sm mt-1">{createFormErrors.instruction_type}</p>
                  )}
                </div>

                {/* Select Instruction Method */}
                <div>
                  <label className="block font-medium mb-1">Select Instruction Method *</label>
                  <select
                    name="instruction_method"
                    value={createFormData.instruction_method}
                    onChange={handleCreateInputChange}
                    className="w-full border p-2 rounded"
                  >
                    <option value="">Select instruction method</option>
                    <option value="Email">Email</option>
                    <option value="Phone Call">Phone Call</option>
                    <option value="SMS">SMS</option>
                    <option value="Whatsapp">Whatsapp</option>
                    <option value="Face To Face">Face To Face</option>
                    <option value="Fax">Fax</option>
                  </select>
                  {createFormErrors.instruction_method && (
                    <p className="text-red-500 text-sm mt-1">{createFormErrors.instruction_method}</p>
                  )}
                </div>

                {/* Assign to Different Consultant Checkbox */}
                <div className="flex items-center mb-4">
                  <input
                    type="checkbox"
                    id="assignToDifferentConsultant"
                    checked={assignToDifferentConsultant}
                    onChange={(e) => setAssignToDifferentConsultant(e.target.checked)}
                    className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                  />
                  <label htmlFor="assignToDifferentConsultant" className="ml-2 block text-sm font-medium text-gray-700">
                    Assign This Instruction To A Different Consultant
                  </label>
                </div>

                {/* Search For Consultant Field - Conditionally Rendered */}
                {assignToDifferentConsultant && (
                  <div>
                    <label className="block font-medium mb-1">Search For Consultant *</label>
                    <input
                      type="text"
                      placeholder="Type to search for consultants..."
                      value={consultantSearchTerm}
                      onChange={(e) => setConsultantSearchTerm(e.target.value)}
                      className="w-full border p-2 rounded"
                    />
                    {selectedConsultantId && (
                      <p className="text-green-600 text-sm mt-1">Consultant selected</p>
                    )}
                    
                    {/* Consultant Search Results */}
                    {consultantSearchTerm && !selectedConsultantId && filteredConsultants.length > 0 && (
                      <div className="mt-2 max-h-40 overflow-y-auto border rounded">
                        {filteredConsultants.map(consultant => (
                          <div
                            key={consultant.id}
                            className="p-2 hover:bg-gray-100 cursor-pointer border-b"
                            onClick={() => handleConsultantSelect(consultant.id, `${consultant.name} ${consultant.surname}`)}
                          >
                            <div className="font-medium">{consultant.name} {consultant.surname}</div>
                            <div className="text-sm text-gray-600">{consultant.email}</div>
                          </div>
                        ))}
                      </div>
                    )}
                    
                    {/* Clear selection button */}
                    {selectedConsultantId && (
                      <button
                        type="button"
                        onClick={() => {
                          setSelectedConsultantId('');
                          setCreateFormData(prev => ({ ...prev, consultant_id: '' }));
                          setConsultantSearchTerm('');
                        }}
                        className="text-red-500 text-sm mt-1 underline"
                      >
                        Clear consultant selection
                      </button>
                    )}
                  </div>
                )}

                {/* Description */}
                <div>
                  <label className="block font-medium mb-1">Description *</label>
                  <textarea
                    name="description"
                    value={createFormData.description}
                    onChange={handleCreateInputChange}
                    className="w-full border p-2 rounded h-32"
                    placeholder="Enter instruction description..."
                  />
                  {createFormErrors.description && (
                    <p className="text-red-500 text-sm mt-1">{createFormErrors.description}</p>
                  )}
                </div>
              </div>

              <div className="mt-6 flex justify-end space-x-2">
                <button
                  type="button"
                  className="bg-gray-300 text-black px-4 py-2 rounded hover:bg-gray-400"
                  onClick={() => {
                  setIsCreateModalOpen(false);
                  setAssignToDifferentConsultant(false); // Reset checkbox
                  setConsultantSearchTerm(''); // Reset consultant search
                  setSelectedConsultantId(''); // Reset selected consultant
                }}
              >
                  Cancel
                </button>

                <button
                  type="submit"
                  className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                >
                  Create Instruction
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

    </div>
  );
};

export default Instructions;